import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function EditStorageItem (){
  const {user} = useUser()
  let view = contentLayout[modules.EditStorageItem]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.EditStorageItem.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.EditStorageItem}></Index>
 )
}

export default EditStorageItem